import styled, { CSSProperties } from 'styled-components';

type Props = {
  fit?: boolean;
};

const Root = styled.div<Props>`
  margin-bottom: ${({ theme, fit }) => (fit ? 0 : theme.spaces.xxl)};
  padding: ${({ theme }) =>
    `${theme.spaces.xxxxl} ${theme.spaces.xxl} ${theme.spaces.ex}`};
  border-radius: ${({ theme, fit }) =>
    fit ? `${theme.radii.m} ${theme.radii.m} 0 0` : theme.radii.m};

  background: url('data:image/svg+xml;charset=utf8,%3Csvg%20width%3D%2236%22%20height%3D%2230%22%20viewBox%3D%220%200%2036%2030%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M19.0824%200H8.4519V8.61347H15.052V5.95765H19.0824C24.4658%205.95765%2028.1229%209.68657%2028.1229%2015.0018V15.0736C28.1229%2020.3924%2024.4801%2024.0459%2019.0824%2024.0459H15.052V21.3758H8.4519V29.9892H19.0824C28.5105%2029.9892%2035.0245%2023.4322%2035.0245%2014.991V14.9049C35.0245%206.4601%2028.5105%200%2019.0824%200Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M19.0824%200H8.4519V8.61347H15.052V5.95765H19.0824C24.4658%205.95765%2028.1229%209.68657%2028.1229%2015.0018V15.0736C28.1229%2020.3924%2024.4801%2024.0459%2019.0824%2024.0459H15.052V21.3758H8.4519V29.9892H19.0824C28.5105%2029.9892%2035.0245%2023.4322%2035.0245%2014.991V14.9049C35.0245%206.4601%2028.5105%200%2019.0824%200Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M15.052%2011.8579V18.1457H2.03489C1.4952%2018.1457%200.977602%2017.9313%200.595978%2017.5497C0.214354%2017.1681%20-4.03834e-05%2016.6505%20-4.03834e-05%2016.1108V13.8928C-4.03834e-05%2013.3531%200.214354%2012.8355%200.595978%2012.4539C0.977602%2012.0723%201.4952%2011.8579%202.03489%2011.8579H15.052V11.8579Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E') no-repeat center center;

  background-size: 600px;
  background-position: right;
  background-color: ${({ theme }) => theme.backgroundColors.blue};
  background-blend-mode: soft-light;

  ${({ theme }) =>
    theme.screen.sp({
      padding: `${theme.spaces.xxxl} ${theme.spaces.xl}`,
    })}
}
`;

const Wrapper = styled.div`
  max-width: ${({ theme }) => theme.windowSizes.m};
  margin: 0 auto;
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.fontColors.white};
  font-size: ${({ theme }) => theme.fontSizes.xxxl};
  line-height: ${({ theme }) => theme.lineHeights.l};
`;

const Description = styled.p`
  color: ${({ theme }) => theme.fontColors.white};
  font-size: ${({ theme }) => theme.fontSizes.m};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: ${({ theme }) => theme.lineHeights.m};

  ${({ theme }) =>
    theme.screen.sp({
      fontSize: theme.fontSizes.s,
    })}
`;

export const Heading = Object.assign(Root, { Wrapper, Title, Description });
